"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AppLogo", {
  enumerable: true,
  get: function get() {
    return _AppLogo["default"];
  }
});
Object.defineProperty(exports, "CollapseAction", {
  enumerable: true,
  get: function get() {
    return _CollapseAction["default"];
  }
});
Object.defineProperty(exports, "Label", {
  enumerable: true,
  get: function get() {
    return _Label["default"];
  }
});
Object.defineProperty(exports, "LabelHeader", {
  enumerable: true,
  get: function get() {
    return _LabelHeader["default"];
  }
});
Object.defineProperty(exports, "Labels", {
  enumerable: true,
  get: function get() {
    return _Labels["default"];
  }
});
Object.defineProperty(exports, "NavSection", {
  enumerable: true,
  get: function get() {
    return _NavSection["default"];
  }
});
Object.defineProperty(exports, "Usage", {
  enumerable: true,
  get: function get() {
    return _Usage["default"];
  }
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Label = _interopRequireDefault(require("./components/Label"));
var _Labels = _interopRequireDefault(require("./components/Labels"));
var _AppLogo = _interopRequireDefault(require("./components/AppLogo"));
var _NavSection = _interopRequireDefault(require("./components/NavSection"));
var _LabelHeader = _interopRequireDefault(require("./components/LabelHeader"));
var _CollapseAction = _interopRequireDefault(require("./components/CollapseAction"));
var _Usage = _interopRequireDefault(require("./components/Usage"));
var _default = exports["default"] = function _default(_ref) {
  var logo = _ref.logo,
    children = _ref.children,
    footer = _ref.footer,
    activeAccount = _ref.activeAccount;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "max-h-screen min-h-screen flex flex-col"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-shrink-0 flex items-center px-6 pt-8 pb-2",
    style: {
      height: 70
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-32"
  }, logo)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-grow overflow-auto pb-10",
    style: {
      height: 'calc(100vh - 70px)'
    }
  }, children), footer && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-shrink-0"
  }, footer), activeAccount && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-shrink-0"
  }, activeAccount));
};
//# sourceMappingURL=index.js.map